module.exports = __webpack_public_path__ + "media/product.2700cb1e.mp4";